import { parseApiDetailObject, type ParsedApiError } from "./apiErrors";

export type FetchApiError = ParsedApiError & {
  suggestions: string[];
};

/** Parse a non-ok ``fetch`` response body (FastAPI ``detail`` envelope). */
export async function parseFetchApiError(
  res: Response,
  fallbackMessage = "Request failed. Please try again.",
): Promise<FetchApiError> {
  try {
    const body = await res.json();
    const parsed = parseApiDetailObject(body?.detail, fallbackMessage);
    return {
      ...parsed,
      suggestions: parsed.suggestions ?? [],
    };
  } catch {
    let message = fallbackMessage;
    if (res.status === 403) {
      message = "Security filter blocked your request due to sensitive content like phone numbers or links. Please remove them and try again.";
    } else if (res.status !== 200 && fallbackMessage === "Request failed. Please try again.") {
      // Never surface a raw status code to the user — read as a broken app.
      // Same reassuring copy the backend uses for generation failures.
      message = "We are experiencing high volume right now. Please try again in a moment.";
    }

    return {
      message,
      missingFields: [],
      isSellerOnboardingIncomplete: false,
      isDailyQuotaExceeded: false,
      isSellerNotVerified: false,
      isBuyerNotVerified: false,
      isLlmError: false,
      suggestions: [],
    };
  }
}

export async function fetchApiErrorMessage(
  res: Response,
  fallbackMessage = "Request failed. Please try again.",
): Promise<string> {
  return (await parseFetchApiError(res, fallbackMessage)).message;
}
